module.exports = __webpack_public_path__ + "static/media/vsv.e050e5fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/vsv.png
// module id = 181
// module chunks = 0